import api, { apiEndpoints } from 'shared/services/axios';

export type ExternalAvailableAppointmentsQueryParams = {
  from: string;
  to: string;
  addressLines: string;
  municipality: string;
  region: string;
  countryCode: string;
  postalCode?: string;
  latitude?: string;
  longitude?: string;
  fulfillmentAgreementId?: string;
  rootProductInstanceId?: string;
  shoppingCartId?: string;
};
export type Schedule = {
  from: string;
  to: string;
};

export type AvailableAppointments = {
  timezone: string;
  schedules: Schedule[];
};

export default async (input: ExternalAvailableAppointmentsQueryParams): Promise<AvailableAppointments> => {
  const { data } = await api.post<AvailableAppointments>(apiEndpoints.getAvailableAppointments, { ...input });
  return data;
};
